import React from 'react';

/** Bloc factuel answer-first pour SEO/GEO — 40–60 mots, visible en tête de page. */
const GeoSummary = ({ children, className = '' }) => {
  if (!children) return null;
  return (
    <section
      className={`geo-summary border-l-4 border-primary-600 bg-primary-50/40 pl-4 pr-3 py-3 my-4 text-gray-800 leading-relaxed text-base ${className}`}
      aria-label="Summary"
    >
      <p className="m-0">{children}</p>
    </section>
  );
};

export default GeoSummary;
